import { Injectable } from '@angular/core';
import { AppConstants } from 'src/app-constants';
import { AccountClient } from '../clients/account.client';
import { ApiRequest } from '../service-models/api-contracts/base/api-request';
import { ApiResponse } from '../service-models/api-contracts/base/api-response';
import { RoleTypeSM } from '../service-models/enums/role-type-s-m.enum';
import { TokenRequestSM } from '../service-models/token/token-request-s-m';
import { TokenResponseSM } from '../service-models/token/token-response-s-m';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class SampleService extends BaseService {

  constructor(private accountClient: AccountClient) {
    super();
  }

  async generateToken(tokenReq: TokenRequestSM): Promise<ApiResponse<TokenResponseSM>> {
    if (tokenReq == null || tokenReq.loginId == null)// null checks
    {
      throw new Error(AppConstants.ErrorPrompts.Invalid_Input_Data);
    }
    else {
      let apiRequest = new ApiRequest<TokenRequestSM>();
      tokenReq.companyCode = '123';
      tokenReq.roleType = RoleTypeSM.ClientAdmin;
      apiRequest.reqData = tokenReq
      return await this.accountClient.GenerateToken(apiRequest);
    }
  }
}
